var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"type":_vm.type,"size":_vm.size,"loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.resend}},[_vm._v(" Resend ")])}
var staticRenderFns = []

export { render, staticRenderFns }